import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";
import { reportError } from "../lib/report.ts";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * A render crash replaces the screen with a way out instead of a blank page,
 * and the crash goes to the server log. Keyed on the route by its parent, so
 * navigating elsewhere clears it.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportError(error, { componentStack: (info.componentStack ?? "").slice(0, 500) });
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="page py-20">
        <p className="label text-stop">Écran planté</p>
        <p className="mt-2 text-[0.95rem] text-ink-soft">
          L'erreur a été envoyée au serveur. Les séries déjà validées sont enregistrées.
        </p>
        <button
          type="button"
          onClick={() => location.reload()}
          className="mt-6 h-12 rounded-card bg-ink px-6 font-bold text-[var(--color-base)] active:bg-ink/85"
        >
          Recharger
        </button>
      </div>
    );
  }
}
